module.exports = __webpack_public_path__ + "static/media/graphic.42963065.jpg";